import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaHotel, FaCalendarAlt, FaBed, FaWifi, FaPhotoVideo, FaEuroSign, FaGlobe, FaMobileAlt, FaSearch, FaComments, FaCode, FaRocket } from 'react-icons/fa';
import Button from '../../components/Button';

const WebHotelesPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/servicios/diseno-web-restaurantes", text: "Página web barata para restaurantes" },
    { url: "/servicios/diseno-web-inmobiliarias", text: "Página web barata para inmobiliarias" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para pymes" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Reservas directas sin pagar comisiones",
      description: "Evita comisiones de hasta el 25% que cobran Booking, Expedia o Airbnb. Más ingresos por cada reserva y contacto directo con tus clientes."
    },
    {
      title: "Capta clientes mientras duermes",
      description: "Tu web trabaja 24/7, permitiendo que viajeros de todo el mundo conozcan tu hotel y reserven en cualquier momento, sin importar horarios o zonas horarias."
    },
    {
      title: "Compite con cadenas hoteleras sin su presupuesto",
      description: "Una web profesional te pone al nivel de competidores más grandes. Los viajeros juzgan la calidad de un hotel por su presencia online."
    },
    {
      title: "Control total sobre precios y disponibilidad",
      description: "Actualiza tarifas, promociones y disponibilidad instantáneamente según tus necesidades, sin depender de la aprobación de terceros."
    },
    {
      title: "Crea paquetes y ofertas exclusivas",
      description: "Diseña promociones especiales solo disponibles en tu web: descuentos por reserva directa, ofertas de última hora o paquetes con servicios adicionales."
    },
    {
      title: "Recupera la inversión con pocas reservas",
      description: "Con solo 2-3 reservas directas recuperas el coste total de la web. La mayoría de nuestros clientes hoteleros lo consiguen en el primer mes."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaHotel />,
      title: "Presentación profesional que convence",
      description: "Mostramos tus habitaciones e instalaciones de forma atractiva y honesta, con fotografías optimizadas y descripciones que generan reservas."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de reservas sin comisiones",
      description: "Integramos un motor de reservas que permite a tus clientes consultar disponibilidad, seleccionar habitaciones y pagar directamente."
    },
    {
      icon: <FaSearch />,
      title: "SEO local para aparecer ante viajeros",
      description: "Optimizamos tu web para que aparezca cuando alguien busca 'hotel en [tu ciudad]', generando tráfico de calidad que se convierte en reservas."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en móviles, donde se hacen las reservas",
      description: "El 67% de reservas hoteleras se realizan desde dispositivos móviles. Tu web funcionará perfectamente en cualquier pantalla, sin excepciones."
    },
    {
      icon: <FaEuroSign />,
      title: "Precio final sin sorpresas",
      description: "Desde 200€ (pago único) y 20€/mes de mantenimiento con actualizaciones ilimitadas. Sin costes ocultos ni comisiones por reserva."
    },
    {
      icon: <FaGlobe />,
      title: "Versiones en varios idiomas",
      description: "Incluimos versiones en español e inglés para que puedas atraer turistas nacionales e internacionales. Otros idiomas disponibles si los necesitas."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para hoteles pequeños y hostales que necesitan una web profesional para empezar a recibir reservas.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por hoteles. Equilibrio perfecto entre precio y funcionalidades para aumentar reservas directas.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para hoteles que quieren destacar con más funcionalidades y mejor posicionamiento para captar más clientes.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis de tu hotel y competencia",
      description: "Estudiamos tu establecimiento, servicios, tipos de habitaciones y competidores directos para crear una web que destaque tus ventajas competitivas.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en tiempo récord",
      description: "Creamos tu web en 10-15 días con un diseño profesional que transmite la calidad de tu hotel y está optimizado para conseguir reservas directas.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y primeras reservas",
      description: "Activamos tu web con el sistema de reservas configurado y te enseñamos a gestionarla. Te ayudamos a promocionarla para empezar a recibir reservas directas.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño especializado en sector hotelero",
      us: true,
      others: false
    },
    {
      label: "Sistema de reservas sin comisiones mensuales",
      us: true,
      others: false
    },
    {
      label: "Enfoque en conversión de visitas a reservas",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Precio final sin costes ocultos",
      us: true,
      others: false
    },
    {
      label: "Actualizaciones ilimitadas incluidas",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Después de años dependiendo de Booking y pagando comisiones altísimas, decidí invertir en una web propia con sistema de reservas. En tres meses, las reservas directas pasaron del 5% al 35% del total. La inversión se amortizó en semanas y ahora tengo control total sobre mis precios y promociones. Además, el contacto directo con los clientes me permite ofrecerles un mejor servicio.",
    author: "Carlos Mendoza",
    position: "Propietario",
    company: "Hotel Costa Azul",
    avatar: "/servicios/testimonios/hotelero.webp"
  };
  
  const founderMessage = "En el sector hotelero, cada reserva que viene de Booking o Expedia significa perder entre el 15-25% en comisiones. Desarrollamos webs hoteleras pensando en la independencia: cada reserva directa que consigues es una comisión que ahorras, además de ganar control total sobre la experiencia de tus huéspedes.";
  
  // FAQs específicas para hoteles
  const faqs = [
    {
      question: "¿Por qué necesito una web propia teniendo perfil en Booking y otros portales?",
      answer: "Los portales como Booking, Expedia o Airbnb son útiles para dar visibilidad, pero tienen importantes desventajas: cobran comisiones altas (15-25% por reserva), controlan la comunicación con tus clientes, muestran a tu competencia junto a tu perfil, limitan tu presentación visual, y pueden cambiar sus políticas o tarifas unilateralmente. Una web propia te permite: recibir reservas sin comisiones (recuperando la inversión rápidamente), crear una relación directa con tus clientes, presentar tu hotel tal como deseas, ofrecer paquetes y servicios exclusivos, y recopilar datos para remarketing. La mayoría de nuestros clientes hoteleros utilizan ambos canales: portales para visibilidad inicial y web propia para fidelizar y aumentar reservas directas, logrando incrementos del 20-40% en reservas sin intermediarios en los primeros 6 meses.",
      category: "Estrategia"
    },
    {
      question: "¿Cómo funciona el sistema de reservas y qué comisiones aplica?",
      answer: "Nuestro sistema de reservas integrado (incluido en los planes Profesional y Premium) permite a los clientes consultar disponibilidad en tiempo real, seleccionar habitaciones, añadir servicios adicionales y completar el pago online. A diferencia de otros proveedores, no cobramos comisión por reserva ni tarifas mensuales variables - solo el mantenimiento fijo de 25€/mes que incluye todas las actualizaciones. El sistema se puede configurar según tus preferencias: depósitos parciales o pago completo, diferentes políticas de cancelación, códigos promocionales, etc. También podemos integrarlo con tu PMS (Property Management System) si ya utilizas uno, o con tu calendario de Google/Outlook para mantener la disponibilidad actualizada automáticamente.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cómo conseguiré que mi web atraiga viajeros y genere reservas reales?",
      answer: "Nuestras webs para hoteles están diseñadas específicamente para convertir visitantes en huéspedes, no solo para verse bonitas. Esto lo logramos mediante: optimización SEO local para aparecer cuando alguien busca alojamiento en tu zona, diseño centrado en la conversión con fotografías de calidad y descripciones persuasivas, proceso de reserva simplificado que minimiza abandonos, elementos de credibilidad (opiniones, certificaciones, distinciones), ofertas exclusivas para reservas directas, y carga rápida que mejora la experiencia. Además, te asesoramos sobre cómo promocionar tu hotel en Google Hotel Ads, Google My Business, redes sociales y otros canales relevantes. El 82% de nuestros clientes hoteleros reportan un aumento significativo en reservas directas durante los primeros tres meses tras el lanzamiento.",
      category: "Resultados"
    },
    {
      question: "¿Puedo actualizar yo mismo los precios, disponibilidad y contenidos?",
      answer: "Absolutamente. Todas nuestras webs para hoteles incluyen un panel de control intuitivo que te permite actualizar tarifas, disponibilidad, promociones, fotografías y cualquier otro contenido sin conocimientos técnicos. Te proporcionamos un video tutorial personalizado mostrando cómo realizar las tareas habituales en tu propia web. Si utilizas un PMS, podemos integrarlo para que la actualización de disponibilidad sea automática. Para hoteles que prefieran no ocuparse de las actualizaciones, incluimos en el mantenimiento mensual actualizaciones ilimitadas - solo nos envías los cambios por WhatsApp o email y los aplicamos por ti, generalmente en el mismo día.",
      category: "Gestión"
    },
    {
      question: "¿En cuánto tiempo estará lista mi web con sistema de reservas?",
      answer: "El tiempo de desarrollo para una web hotelera estándar es de 10-15 días laborables desde la aprobación del diseño y la recepción de los materiales necesarios (logotipo, fotografías de habitaciones e instalaciones, lista de servicios, tipos de habitaciones y tarifas). Para el plan Premium con integración a PMS, el plazo puede extenderse hasta 20 días dependiendo del sistema utilizado. Este tiempo incluye: diseño personalizado según tu imagen corporativa, configuración del sistema de reservas, carga de habitaciones y tarifas, optimización SEO, pruebas de funcionamiento y capacitación para su uso. Trabajamos ágilmente para que puedas empezar a recibir reservas directas lo antes posible.",
      category: "Plazos"
    },
    {
      question: "¿La web será multiidioma para atraer turistas internacionales?",
      answer: "Sí, nuestros planes Profesional y Premium incluyen versiones en español e inglés como estándar. Esto es fundamental en el sector hotelero, ya que permite atraer tanto a turistas nacionales como internacionales. Para hoteles con públicos específicos, podemos añadir idiomas adicionales como francés, alemán, italiano o ruso con un coste extra de 150€ por idioma. El sistema de reservas funciona automáticamente en el idioma que el visitante esté utilizando. Las estadísticas muestran que ofrecer la web en el idioma nativo del visitante aumenta la probabilidad de reserva en un 70%, especialmente para turistas internacionales que buscan alojamiento independiente con trato personalizado.",
      category: "Funcionalidades"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para hoteles
      pageTitle="Página Web para Hoteles desde 200€ | Sistema de Reservas Sin Comisiones"
      pageDescription="Diseñamos webs para hoteles con sistema de reservas directo sin intermediarios. Aumenta tus reservas directas y elimina comisiones de Booking o Expedia."
      pageKeywords="página web barata hoteles, diseño web hotel, sistema reservas hotel, web sin comisiones hotel, página web hostal"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-hoteles"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para hoteles desde 200€ (sin comisiones por reserva)"
      heroSubtitle="Webs profesionales para hoteles y alojamientos con reservas directas sin intermediarios. Sin costes ocultos ni comisiones, lista en 14 días."
      heroImage="/servicios/tipo-cliente/hero-hoteles.webp"
      badges={['Desde 200€ (pago único)', 'Sistema de reservas incluido', 'Sin comisiones por habitación', 'Integración con PMS']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de hotel"
      pricingSubtitle="Elige el plan que mejor se adapte a las necesidades de tu hotel. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras webs son ideales para hoteles?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Jaime Vela"
            founderTitle="Co-fundador y Director de Marketing"
            avatarSrc="/sobre nosotros/foto-jaime.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web hotelera: profesional y orientada a resultados"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué los hoteles nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una web profesional para tu hotel?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para hoteles"
      faqCategories={["Estrategia", "Funcionalidades", "Resultados", "Gestión", "Plazos"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu hotel con reservas directas sin intermediarios"
      ctaDescription="Empieza a recibir reservas sin comisiones. Tu web trabaja para ti 24/7 mientras te dedicas a dar el mejor servicio a tus huéspedes."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebHotelesPage; 

